import React from 'react';
import PropTypes from 'prop-types';
import { SearchKeywordSpan, SearchKeywordWrapper } from './styled';

const SearchKeyword = ({ left, keyword, margin, noResults }) => (
  <SearchKeywordWrapper left={left} margin={margin}>
    <SearchKeywordSpan data-cy="text-search-keyword">
      {noResults ? `No results found for your search, "${keyword}"` : `You searched for "${keyword}"`}
    </SearchKeywordSpan>
  </SearchKeywordWrapper>
);

SearchKeyword.propTypes = {
  keyword: PropTypes.string.isRequired,
  left: PropTypes.bool,
  margin: PropTypes.string,
  noResults: PropTypes.bool,
};

export default SearchKeyword;
